<template>
<StoreModal
        name="RemoveApiKeysModal"
        class="remove-api-keys-modal"
        :title="title"
        @closeModal="handleCancelCreate"
>
    <template #header>
        <div class="remove-api-keys-modal__header">
            <svg width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clip-path="url(#clip0_9538_71753)">
                    <rect width="60" height="60" rx="10" fill="#DAC066"/>
                    <path d="M24.8098 18.2197C24.9504 18.079 25.1412 18 25.3401 18H34.6599C34.8588 18 35.0496 18.079 35.1902 18.2197L41.7803 24.8098C41.921 24.9504 42 25.1412 42 25.3401V34.6599C42 34.8588 41.921 35.0496 41.7803 35.1902L35.1902 41.7803C35.0496 41.921 34.8588 42 34.6599 42H25.3401C25.1412 42 24.9504 41.921 24.8098 41.7803L18.2197 35.1902C18.079 35.0496 18 34.8588 18 34.6599V25.3401C18 25.1412 18.079 24.9504 18.2197 24.8098L24.8098 18.2197ZM25.6508 19.5L19.5 25.6508V34.3492L25.6508 40.5H34.3492L40.5 34.3492V25.6508L34.3492 19.5H25.6508Z" fill="white"/>
                    <path d="M28.5023 34.5C28.5023 33.6716 29.1739 33 30.0023 33C30.8307 33 31.5023 33.6716 31.5023 34.5C31.5023 35.3284 30.8307 36 30.0023 36C29.1739 36 28.5023 35.3284 28.5023 34.5Z" fill="white"/>
                    <path d="M28.6493 25.4926C28.5693 24.6934 29.1969 24 30 24C30.8031 24 31.4307 24.6934 31.3507 25.4926L30.8246 30.7537C30.7823 31.1774 30.4258 31.5 30 31.5C29.5742 31.5 29.2177 31.1774 29.1754 30.7537L28.6493 25.4926Z" fill="white"/>
                </g>
                <defs>
                    <clipPath id="clip0_9538_71753">
                        <rect width="60" height="60" fill="white"/>
                    </clipPath>
                </defs>
            </svg>
            <div class="title">
                {{ title }}
            </div>
        </div>
    </template>
    <template #body>
        <template v-if="!isLoading">
            <div class="remove-api-keys-modal__container" v-if="!isSuccess">
                <p class="remove-api-keys-modal__message">
                    {{ $t('api_keys.are_you_sure') }}
                </p>
                <p class="remove-api-keys-modal__alias" v-if="alias">{{ alias }}</p>
            </div>
            <div class="remove-api-keys-modal__container" v-else>
                <p class="remove-api-keys-modal__message">
                    {{ $t('api_keys.successful_deletion') }}
                </p>
            </div>
        </template>
        <LoadingSpinner
                v-else
                :title="deleting_an_api_key"
        />
    </template>

    <template #footer>
      <div class="footer" v-if="!isSuccess">
        <base-button :label="$t('api_keys.close')" type="secondary" @click="handleCancelCreate" />
        <base-button
            type="primary"
            :label="$t('api_keys.delete')"
            @click="handleRemoveRequest"
        />
      </div>
      <base-button
          v-else
          class="remove-api-keys-modal__full-width-btn"
          type="primary"
          :label="$t('api_keys.close')"
          @click="handleCancelCreate"
      />
    </template>

  </StoreModal>
</template>

<script>

import {mapState, mapGetters, mapActions} from 'vuex';

import AtModal from 'at-ui/src/components/modal';
import LoadingSpinner from "/public/components/common/uiKit/spinner/index.vue";;
import AtButton from 'at-ui/src/components/button';
import BaseModal from "../BaseModal";
import BaseButton from "@/public/components/common/uiKit/button/base/index.vue";

export default {
    name: 'RemoveApiKeysModal',
    components: {
        BaseButton,
        BaseModal,
        AtModal,
        LoadingSpinner,
        AtButton,
        StoreModal: () => import(/* webpackChunkName: "/public/components/modals/StoreModal" */ '/public/components/modals/StoreModal'),
    },
    data() {
        return {
            isLoading: false,
            isSuccess: false,
        };
    },
    computed: {
        ...mapState('app', {
            modalPayload: state => state.modal.payload,
        }),
        ...mapGetters('app', [
            'isOpenModal',
        ]),
        isOpen() {
            const {
                $options: {
                    name,
                },
                isOpenModal,
            } = this;

            return isOpenModal(name);
        },
        title() {
            return this.$t(this.isSuccess ? 'api_keys.successful_deletion' : 'api_keys.deleting_an_api_key');
        },
        alias() {
            return this.modalPayload?.alias ?? '';
        },
        hideFooter() {
            const {
                isLoading,
                isSuccess,
            } = this;

            return isLoading || isSuccess;
        },
        deleting_an_api_key() {
            return this.$t('api_keys.deleting_an_api_key');
        },
    },
    methods: {
        ...mapActions('app', [
            'openModal',
            'closeModal',
        ]),
        ...mapActions('user', [
            'removeApiKeys',
            'fetchApiKeys',
        ]),
        clearAllData() {
            this.isLoading = false;
            this.isSuccess = false;
        },
        handleRemoveRequest() {
            const {
                modalPayload: {
                    id,
                },
                removeApiKeys,
                fetchApiKeys,
            } = this;

            this.openModal({
                name: 'TwoFaConfirmation',
                payload: {id}
            });
            // removeApiKeys({id: apiKeysId})
            //     .then(status => {
            //         this.isSuccess = status;
            //         fetchApiKeys();
            //     })
            //     .finally(() => {
            //         this.closeModal();
            //         this.isLoading = false;
            //     });
        },
        handleCancelCreate() {
            const {
                closeModal,
                clearAllData,
            } = this;

            closeModal();

            setTimeout(() => {
                clearAllData();
            }, 500);
        },
    },
};

</script>

<style lang="scss" scoped>
.footer {
  display: flex;
  align-items: center;
  gap: 20px;
}
.title {
    font-family: $Gilroy;
    font-size: $h1;
    font-weight: 500;
    color: var(--new-front-primary-font-color);
    @media (max-width: 576px) {
        font-size: $h3;
    }
}
.remove-api-keys-modal {
  font-family: $Gilroy;
  &__full-width-btn {
    width: 100%;
  }
  &__container {
    padding: 0 20px;
  }
  &__header {
    display: flex;
    flex-direction: column;
    align-items: center;
      gap: 30px;
    text-align: center;

    .title {
      font-family: $Gilroy;
      font-size: $h1;
      font-weight: 500;
      color: var(--new-front-primary-font-color);
      @media (max-width: 450px) {
        font-size: $h2;
      }
    }
  }
  &__message {
      margin-top: 20px;
    font-family: $Gilroy;
      font-size: 16px;
    font-weight: 500;
    color: var(--new-front-secondary-font-color);
    text-align: center;
  }

  &__alias {
    font-family: $Gilroy;
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 19px;
    color: var(--new-front-primary-font-color);
    margin-top: 5px;
      margin-bottom: 30px;
      text-align: center;
  }

  //::v-deep .at-modal__footer {
  //  padding-left: 16px;
  //  padding-right: 16px;
  //}
}

</style>
